export const baseUrl = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3333'
